import React from 'react'
import { useIntl } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import noop from 'lib/function/noop'
import CreateTripItem from 'tripPlanner/components/TripModal/TripItems/Create'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

interface Props {
  tripId: string
  onClick?: () => void
}

function AddCustomHotelCTA({ tripId, onClick = noop }: Props) {
  const intl = useIntl()
  const openModal = useOpenModal()

  return (
    <TextButton
      kind="secondary"
      onClick={() => {
        onClick()
        openModal(CreateTripItem, {
          itemType: 'ACCOMMODATION',
          tripId,
        })
      }}
      data-testid="add-custom-hotel-cta"
    >
      {intl.formatMessage({
        id: 'vYPDwZBd9Z53zFSnxmX_',
        defaultMessage: 'Add my own',
        description: 'Button to manually add a custom hotel to trip planner',
      })}
    </TextButton>
  )
}

export default AddCustomHotelCTA
